import { observer } from 'mobx-react-lite';
import { useEventMetadataStore } from '~/event-panel/event-panel-form/event-metadata';
import { useOpenFrEventDetails } from '~/fr-event-details-page/hooks/use-open-fr-event-details';
import { FrEventDetailsTab, FrEventDetailsTabConfig } from '~/fr-event-details-page/types';
import { useEnabledFeatures } from '~/common/hooks/enabled-features/use-enabled-features';
import { getUniversalSearchLabel } from '~/common/helpers/get-usx-labels';
import { FrTab } from '~/fr-event-common-components/fr-tab';
import { FrTabs } from '~/fr-event-common-components/fr-tabs';

export const FrEventDetailsTabsHeader = observer(function FrEventDetailsTabsHeader({
    activeTab,
    tabConfigs,
    eventId,
}: {
    activeTab?: FrEventDetailsTab;
    tabConfigs: FrEventDetailsTabConfig[];
    eventId: number;
}) {
    const eventMetadata = useEventMetadataStore().state.metadata;
    const enabledFeatures = useEnabledFeatures();
    const openFrEventDetails = useOpenFrEventDetails();

    const tabsToShow = tabConfigs.filter((tabConfig) => {
        if (typeof tabConfig.checkEnabled === 'undefined') return true;
        return tabConfig.checkEnabled(enabledFeatures, eventMetadata);
    });

    return (
        <FrTabs activeTab={activeTab} dataTestId="event-details-tabs">
            {tabsToShow.map((tabConfig) => {
                const tabTitle =
                    tabConfig.type === 'DEX' && enabledFeatures.dexNextEnabled
                        ? `${getUniversalSearchLabel(enabledFeatures.dexNextEnabled)} Activity`
                        : tabConfig.name;
                return (
                    <FrTab
                        key={tabConfig.type}
                        type={tabConfig.type}
                        icon={tabConfig.icon}
                        title={tabTitle}
                        totalTabCount={tabsToShow.length}
                        onClick={() => {
                            openFrEventDetails(eventId, tabConfig.type);
                        }}
                    />
                );
            })}
        </FrTabs>
    );
});
